 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		30: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"/node_modules/litepicker-polyfills-ie11/dist","1":"adobeDigitalData","2":"alertSignUpSection","3":"article","4":"binders","7":"bulkDownload","8":"citedBy","9":"confirmationDialog","10":"copyText","11":"dashboardToolbar","12":"datepicker","13":"disableADBlocker","14":"downloadCitations","15":"eventPage","16":"examCertificate","17":"exportCitation","18":"fancybox","19":"favorites","20":"headerAlt","21":"healthcareDisclaimer","22":"institutionBanner","23":"institutionDetails","24":"institutionSearch","25":"keveladplaceholder","26":"lazy-imports","27":"loadAbst","28":"loi","29":"loiAccordion","31":"menu","32":"mrw","33":"pd","34":"personalInformation","36":"profile","37":"progressBar","38":"publicationVersion","39":"readCubeShare","40":"recommendToLibrarian","41":"requestidlecallback-polyfill","42":"sciteMetrics","43":"search","44":"sidebarSections","45":"slideshow","46":"slot-license-consumption","47":"slotLicense","48":"tfa","49":"toggleTable","50":"topContent","51":"truncate","52":"utm","53":"vendors~article","54":"vendors~dynamic-imports","55":"vendors~fancybox","56":"vendors~fileUploader","57":"vendors~ie-imports","58":"vendors~lazy-imports","59":"vendors~pd","60":"vendors~profile","61":"vendors~sciteMetrics","62":"vendors~search","63":"vendors~showRecommended","64":"vendors~slideshow"}[chunkId]||chunkId) + "-" + {"0":"00aee601049681d783f8","1":"6936052290a4483aece2","2":"230422b8ce714adfe843","3":"298e2b98df8dc88239b2","4":"713d7a096813e3734f3e","7":"a356dca008aa69160edc","8":"c73afd6d7a1f19f8225f","9":"67d138f0e22eb39a8e1a","10":"2fd6b01dd1981b71b197","11":"44feef641b2593c9a2bd","12":"d6edb8abe5faef2d119b","13":"69ebc07e6b59bc993b94","14":"83241eb9f8067ba3711f","15":"797049dd63f370fa78d0","16":"8aefd7aa4655fc82184e","17":"27eb4758982ba120d222","18":"7fa997793e22255b9576","19":"05f065a91db76582ba31","20":"417e313d57595e2d8f84","21":"5bcf9013ecb4cfa7f456","22":"2853676d5b50d87b923d","23":"6c734993a0ca96afa9de","24":"b7ff1b77a98f521e1b5d","25":"99e2c995f147879efd6a","26":"085a9a08fec5fc99f717","27":"8027b2be412b0406b659","28":"10b9ef189b6240bf4f16","29":"6e784750d5e62d359d69","31":"463c732320b96bd6ade3","32":"ed77f1e4327e27735bb5","33":"d0ea292184d6ee722fc0","34":"f21600fe554cd651197a","36":"360ce5c9bc59abae587a","37":"4afe5ca5472618d958bf","38":"2b5d7f01d94e859033fa","39":"5eb29af69d3539fea6c3","40":"42cf077b61ed379d5a75","41":"08108c1aa9d3b4a72646","42":"0d8f2afe3b9c2a6af7f2","43":"e67f484093fb8a0ad522","44":"024ae71b27d582cb442f","45":"b9bcadb59422f798157a","46":"4c0dfc441d64fa2e7a72","47":"770964d45e21e4b1fae9","48":"cfc0f3007027fe1e6c77","49":"4689e072be4df6a985d6","50":"db82a0d297f7c573ce3a","51":"d138c80c88754034ad20","52":"c698ebd84d58455987bc","53":"62d298f96f2e3fb977d2","54":"0b81c4f10feab5b0e2e5","55":"6b534c4e32ac6c743f97","56":"cff7a5c1b3c6911d8774","57":"c2dad41ef4ceb4c47fc8","58":"deed4047794e047362c0","59":"431d6494ce84d8121ea5","60":"e75f8c0bad208af84217","61":"f0b89624f129409eadd7","62":"e99d3d438d3e8f05eba6","63":"2a91dcb99826beefdbb0","64":"4a11f2081a3c09a2c8b9","65":"59efb782de0806fcce97"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 107);
